import httpClient from 'httpClient';
import { ENDPOINTS } from 'httpClient/constants';

class NotificationService {
  static getNotificationsHeader() {
    return httpClient.get(ENDPOINTS.notifications, {
      params: null
    });
  }

  static markNotificationAsRead({ notificationId }) {
    return httpClient.put(ENDPOINTS.getNotification(notificationId), {
      notification: {
        read: true
      }
    });
  }

  static markNotificationAsSeen() {
    return httpClient.post(ENDPOINTS.markNotification);
  }

  static async deleteNotification(notificationId) {
    return httpClient.delete(ENDPOINTS.getNotification(notificationId));
  }

  static async acknowledgeNotification(notificationId) {
    return httpClient.post(ENDPOINTS.acknowledgeNotification(notificationId));
  }
}

export default NotificationService;
